import React from 'react';
import {withRouter} from 'next/router';

import Footer from '@deezer/next/shared/layouts/Footer';

import LandingHeader from '@deezer/next/features/Landing/components/LandingHeader';
import BackstageDescription from '@deezer/next/features/Landing/components/BackstageDescription';
import {getServerSideTranslationsWrapper} from '@deezer/next/shared/utils/next';

const LandingContainer = () => {
	return (
		<>
			<LandingHeader />

			<BackstageDescription />
			<Footer />
		</>
	);
};

export const getStaticProps = getServerSideTranslationsWrapper(() => {
	return {
		props: {
			unlogged: true,
			mode: 'light',
		},
	};
});

export default withRouter(LandingContainer);
